export default "__VITE_ASSET__BOOPp79G__"